module.exports = __webpack_public_path__ + "media/images/haircut/card-desktop@3x-198a8f7290b5404ed7a698ae8d3e7210.jpg";